export const ItemTypes = {
  NAMEPLATE: 'nameplate',
  TRIPGRIDCELL: 'tripgridcell',
  ORDERROW: 'orderrow',
  TRAILER_SWAP: 'trailer_swap',
}
export const dropActions = {
  MOVE: 'move',
  INSERT: 'insert',
}
export const shifts = {
  AM: 'am',
  PM: 'pm',
}
export const loadingWindows = {
  NOW: 'now',
  BEFORESIX: 'before 6',
  BEFOREMIDNIGHT: 'before midnight',
  AFTERMIDNIGHT: 'after midnight',
}

export const runoutTimes = {
  NOW: 'now',
  HALFDAY: 'half day',
  DAY: 'next day',
  THREEDAYS: '3 days',
  WEEK: 'week',
}

export const retainTimes = {
  NOW: 'now',
  AMTODAY: 'am today',
  PMTODAY: 'pm today',
  AMTOMORROW: 'am tomorrow',
}
export const dispatchModes = {
  GANTT: 'gantt',
  TRIPGRID: 'tripgrid',
}
export const orderGridTypes = {
  accepted: 'accepted',
}

export const statusClassDict: Record<string, string> = {
  unset: 'scheduled',
  'driving to load': 'driving',
  'arrived at load': 'arrived-at-load',
  loading: 'loading',
  'arrived at drop': 'arrived-at-drop',
  'driving to drop': 'driving',
  dropping: 'dropping',
  'heading home': 'driving',
  complete: 'complete',
}
export const translateStatus = {
  unset: 'Scheduled',
  'driving to load': 'Driving To Load',
  'arrived at load': 'Arrived At Load',
  loading: 'Loading',
  'arrived at drop': 'Arrived At Drop',
  'driving to drop': 'Driving To Drop',
  preview: 'Preview',
  dropping: 'Dropping',
  'heading home': 'Heading Home',
  complete: 'Completed',
}

export const orderColumns = (siteConfig) => {
  const columns = [
    {
      columnName: 'Destinations',
      property: 'destination_name',
      sortable: true,
      columnCount: 3,
    },
    {
      columnName: 'Origins',
      property: 'terminal1_name',
      sortable: true,
      columnCount: 3,
    },
    {
      columnName: 'Products',
      sortable: false,
      columnCount: 3,
    },
    {
      columnName: 'Loading Window',
      property: 'dispatch_window',
      sortable: false,
      columnCount: 3,
    },
    {
      columnName: 'Delivery Window',
      property: 'dispatch_window',
      sortable: true,
      columnCount: 3,
    },
    {
      columnName: 'Runout',
      property: 'dispatch_window_end',
      sortable: true,
      columnCount: 2,
    },
    {
      columnName: 'Updated',
      property: 'updated_on',
      sortable: true,
      columnCount: siteConfig?.multi_truck ? 2 : 3,
    },
    {
      columnName: 'Number',
      property: 'number',
      sortable: true,
      columnCount: siteConfig.multi_truck ? 1 : 2,
    },
    {
      columnName: 'Turn Time',
      property: 'turn_time',
      sortable: true,
      columnCount: 2,
    },
  ]

  if (siteConfig?.multi_truck) {
    const index = columns.findIndex((item) => item.columnName === 'Products')
    columns.splice(index + 1, 0, {
      columnName: 'Trailer',
      property: 'trailer_config',
      sortable: false,
      columnCount: 2,
    })
  }

  return columns.map((c, i) => ({ id: i, ...c }))
}
